
export function setDate(state, data) {
  state.date = data
}

export function setType(state, data) {
    state.type_id = data
}

export function setStaffs(state, data) {
    state.staffs = data
}

export function setScheduleId(state, data) {
    state.scheduleId = parseInt(data)
}

export function schedulePO(state, data) {
    state.schedulePO = data
}
export function confirmTechnician(state, data) {
    state.confirm_technician = data
}
export function confirmClient(state, data) {
    state.confirm_client = data
}

export function setRWT(state, data) {
    state.rwt = data
}

export function setSizeCount(state, data) {
    state.site_count = data
}

export function setBillingAccount(state, data) {
    state.billing_account = data
}

export function setDateHours(state, data) {
    state.datesHours = data
}









